export default {
  ajaxCallsInProgress: 0
};



/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/